export default class {
  constructor(options = {}) {
    this._websocket = null
    this.error_callback = options.error_callback || this.__onError
    this.evalute_callback = options.evalute_callback || this.__onEvalute
    this.state = null
    this.promisePool = []
    this.timeout = 10000
    this.timeoutObj = null
    this.lockReconnect = false
    this.closeConfig = {
      closing: false,
    }
  }
  open() {
    return new Promise(async (resolve, reject) => {
      if ('WebSocket' in window) {
        let aiUrl = localStorage.getItem('evaluation-xfservice')
        if (!aiUrl) {
          aiUrl = await this.__fetchUrl()
        }

        this._websocket = new WebSocket(aiUrl)
        this._websocket.onopen = (e) => {
          console.log(e, 'onopen')
          localStorage.setItem('evaluation-xfservice', aiUrl)
          resolve(e)
        }
        this._websocket.onerror = (e) => {
          console.error(e)
          localStorage.removeItem('evaluation-xfservice')
          this.error_callback(e)
        }
        this._websocket.onclose = (e) => {
          this._websocket = null
          if (!this.closeConfig.closing) {
            // console.log('reconnect')
            // this.reconnect()
            // 对应的重连操作
            this.error_callback(e)
          }
          // 若手动close，恢复初始状态
          this.closeConfig.closing = false
        }
        this._websocket.onmessage = (e) => {
          // this.__heartCheck()
          const data = JSON.parse(e.data)
          // const key = data.guid
          // const req = this.promisePool[key]
          if (data.code == 0) {
            if (data.data.status == 2) {
              this.__close()
            }
            this.evalute_callback(data)
          } else {
            this.__close()
            this.error_callback(data)
          }
        }
      } else {
        reject({
          data: 'Your browser does not support WebSocket!',
        })
      }
    })
  }
  send(data) {
    // return new Promise((resolve, reject) => {
    //     this.promisePool[data.business.guid] = {
    //       resolve,
    //       reject
    //     };

    // })
    if (this._websocket && this._websocket.readyState === 1) {
      this._websocket.send(JSON.stringify(data))
    }
  }
  reconnect() {
    if (this.lockReconnect) return
    // this._websocket = null
    this.lockReconnect = true
    setTimeout(() => {
      this.open()
      this.lockReconnect = false
    }, 2000)
  }
  close() {
    console.log('close')
    if (this._websocket && (this._websocket.readyState === 0 || this._websocket.readyState === 1)) {
      this.closeConfig.closing = true
      this._websocket.close()
    }
  }
  __close() {
    console.log('__close')
    if (this._websocket && this._websocket.readyState === 1) {
      this.closeConfig.closing = true
      this._websocket.close()
      this._websocket.onclose = null
      this._websocket = null
    }
  }
  __onError(e) {
    console.log(e)
  }
  __onEvalute(e) {
    console.log(e)
  }
  __onRecordBegin(e) {
    console.log(e)
  }
  __heartCheck() {
    clearTimeout(this.timeoutObj)
    this.timeoutObj = setTimeout(() => {
      // 心跳时间内收不到消息，主动触发连接关闭，开始重连
      console.log('onclose')
      if (this._websocket.readyState == 1) {
        this.__close()
      }
    }, this.timeout)
  }
  // 获取语音评测地址
  __fetchUrl() {
    return new Promise((resolve) => {
      utilV2.getData(
        ApiPath.xf_evaluation_service,
        //'http://39.105.114.220:8080/mock/v1/app/evaluation-xfyunise-service',
        {
          engine: 'cn_see',
          result_type: 'xml_all',
        },
        (res) => {
          if (res && res.evaluation_url) {
            resolve(res.evaluation_url)
          }
        }
      )
    })
  }
}
